module.exports = __webpack_public_path__ + "static/img/logo_sel.2b419345.jpg";